import { ReactElement } from 'react';
import { Redirect, Route, Switch, useRouteMatch } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import { theme } from './_theme';
import DelegateView from './views/Delegate/DelegateView';
import Navigation from './views/Navigation/NavigationView';
import ReassignView from './views/Reassign/ReassignView';
import RenewView from './views/Renew/RenewView';
import ReviewView from './views/Review/ReviewView';
import ProcessedRequestsView from './views/Review/ProcessedRequests/ProcessedRequestsView';
import TerminateView from './views/Terminate/TerminateView';
import Summary from './views/Summary/Summary';
import EditView from './views/Edit/EditView';
import { UAR_CONSTANTS } from 'pages/UserAccessReview/util/constants';
import UARScaffold from '../UserAccessReview/hoc/Scaffold';

/**
 * User Access Review routes and redirects
 * @returns {ReactElement} React-router routes for User Access Review pages
 */
const UserAccessReviewRoutes = () => {
	const { path } = useRouteMatch();

	return (
		<ThemeProvider theme={theme}>
			<Switch>
				<Route
					path={`${path}/AccountDetails`}
					exact
					render={props => (
						<UARScaffold
							key={UAR_CONSTANTS.PAGE_ACCOUNT_DETAILS}
							pageID={UAR_CONSTANTS.PAGE_ACCOUNT_DETAILS}
							{...props}
						/>
					)}
				/>
				<Route
					path={`${path}/Validate`}
					exact
					render={props => (
						<UARScaffold
							key={UAR_CONSTANTS.PAGE_VALIDATE}
							pageID={UAR_CONSTANTS.PAGE_VALIDATE}
							{...props}
						/>
					)}
				/>
				<Route
					path={`${path}/OrgChart`}
					exact
					render={props => (
						<UARScaffold
							key={UAR_CONSTANTS.PAGE_ORG_CHART}
							pageID={UAR_CONSTANTS.PAGE_ORG_CHART}
							{...props}
						/>
					)}
				/>
				<Route
					path={`${path}/Home`}
					exact
					render={props => <Navigation {...props} />}
				/>
				<Route
					path={`${path}/Delegate`}
					exact
					render={props => <DelegateView {...props} />}
				/>
				<Route
					path={`${path}/Edit`}
					exact
					render={props => <EditView {...props} />}
				/>
				<Route
					path={`${path}/Reassign`}
					exact
					render={props => <ReassignView {...props} />}
				/>
				<Route
					path={`${path}/Renew`}
					exact
					render={props => <RenewView {...props} />}
				/>
				<Route
					path={`${path}/Review/ActionFlow`}
					exact
					render={props => (
						<ReviewView
							showActionFlowOverlay
							{...props}
						/>
					)}
				/>
				<Route
					path={`${path}/Review`}
					exact
					render={props => <ReviewView {...props} />}
				/>
				<Route
					path={`${path}/Review/ProcessedRequests`}
					exact
					render={props => <ProcessedRequestsView {...props} />}
				/>
				<Route
					path={`${path}/Summary`}
					exact
					render={props => <Summary {...props} />}
				/>
				<Route
					path={`${path}/Terminate`}
					exact
					render={props => <TerminateView {...props} />}
				/>
				<Route path={`${path}`}>
					<Redirect to={`${path}/Home`} />
				</Route>
				<Route path={`${path}/*`}>
					<Redirect to={`${path}/Home`} />
				</Route>
				<Route path='*'>404...</Route>
			</Switch>
		</ThemeProvider>
	);
};

export default UserAccessReviewRoutes;
